import DefaultToggle from '../../../../common/components/toggle/DefaultToggle';

interface FormModeToggleProps {
    onChange: (mode: 'json' | 'form') => void;
    disabled?: boolean;
}

export const FormModeToggle = ({ onChange, disabled }: FormModeToggleProps) => {
    return (
        <DefaultToggle
            name="formModeToggle"
            options={[
                { label: 'Text Mode', value: 'json' },
                { label: 'Form Mode', value: 'form' }
            ]}
            className={'qa-configuration-mode-toggle'}
            onChange={(value) => onChange(value === 'json' ? 'json' : 'form')}
            disabled={disabled}
            initialValue="json"
        />
    );
};